/* Events */

import type { Metadata } from './meta';
import type { TelemetryReportData, TransmissionOptions } from './report';

export type EventHandler<Details> = (detail: Details) => void;

export type EventHandlerMap<
  Event extends Record<string, string | number>,
  Details extends Record<Event[keyof Event], unknown>,
> = {
  [key in Event[keyof Event]]?: Array<EventHandler<Details[key]>>;
};

/** List of events Telemetry Service will be listening for (incoming events) */
export enum TelemetryServiceEvent {
  Report = 'telemetry-service:report',
  UpdateMeta = 'telemetry-service:update-meta',
  ReportText = 'telemetry-service:report-text',
}

/** Details of incoming events */
export interface TelemetryServiceReportDetails {
  data: Partial<TelemetryReportData>;
  options?: TransmissionOptions;
}

export interface TelemetryServiceUpdateMetaDetails {
  meta: Partial<Metadata>;
}

export interface TelemetryServiceReportTextDetails {
  data: string;
  options?: TransmissionOptions;
}

export interface TelemetryServiceEventDetails {
  [TelemetryServiceEvent.Report]: TelemetryServiceReportDetails;
  [TelemetryServiceEvent.UpdateMeta]: TelemetryServiceUpdateMetaDetails;
  [TelemetryServiceEvent.ReportText]: TelemetryServiceReportTextDetails;
}

/** List of events emitted by Telemetry Service */
export enum TelemetryServiceOutgoingEvent {
  'BeforeClose' = 'telemetry-service:before-close',
  'BeforeFlush' = 'telemetry-service:before-flush',
}

/** Details of outgoing events */
export interface TelemetryServiceOutgoingEventDetails {
  [TelemetryServiceOutgoingEvent.BeforeClose]: undefined;
  [TelemetryServiceOutgoingEvent.BeforeFlush]: undefined;
}

export interface Transmitter<Data> {
  transmit(data: Data): void;
}
